import { TimePicker } from '~/components/ui/time-picker'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type TimeFieldProps = Omit<FieldProps, 'children' | 'error'> & { disabled?: boolean }

export function TimeField({ label, id, optional, className, ...props }: TimeFieldProps) {
  const field = useFieldContext<string | null>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      className={className}
    >
      <TimePicker
        id={field.name}
        name={field.name}
        value={field.state.value ?? ''}
        onChange={(newValue) => {
          field.handleChange(newValue)
        }}
        ariaInvalid={errorMessage !== undefined}
        minutesStep={10}
        disabled={props.disabled}
      />
    </Field>
  )
}
